/*
 * This class has been auto-generated by the back end. Look for usages of the library no.invarians.lib.es6facadegenerator.
 */
import {ApiClient} from 'api-client';
import {inject} from 'aurelia-framework';

@inject(ApiClient)
export default class Backend {
    apiClient;

    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             paymentMeansId: '[PaymentMeansId]'
     *         }
     * Return dto:
     *     void
     */
    CancelPaymentMeansCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/CancelPaymentMeansCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             endWeekInclusive: '[YearWeek]',
     *             cancellationReason: '[String]',
     *             cancellationComment: '[String]'
     *         }
     * Return dto:
     *     void
     */
    CancelSubscriptionCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/CancelSubscriptionCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             items: {
     *                 productId: '[ProductId]',
     *                 quantity: '[int]',
     *                 oneTime: '[boolean]',
     *                 callersReference: '[String]',
     *                 subItems: {
     *                     productId: '[ProductId]',
     *                     quantity: '[int]',
     *                     oneTime: '[boolean]',
     *                     callersReference: '[String]'
     *                 }
     *             },
     *             weekInterval: '[WeekInterval]',
     *             startWeek: '[YearWeek]',
     *             includeAutoOrderLines: '[Boolean]'
     *         }
     * Return dto:
     *     {
     *         lines: {
     *             productId: '[ProductId]',
     *             articleNumber: '[String]',
     *             description: '[String]',
     *             priceIncVat: '[Money]',
     *             quantity: '[int]',
     *             total: '[Money]',
     *             totalIncVat: '[Money]',
     *             oneTime: '[Boolean]',
     *             automaticLine: '[boolean]',
     *             syntheticLine: '[boolean]',
     *             callersReference: '[String]',
     *             subLines: {
     *                 productId: '[ProductId]',
     *                 articleNumber: '[String]',
     *                 description: '[String]',
     *                 priceIncVat: '[Money]',
     *                 quantity: '[int]',
     *                 totalIncVat: '[Money]',
     *                 oneTime: '[Boolean]',
     *                 automaticLine: '[boolean]',
     *                 syntheticLine: '[boolean]'
     *             }
     *         },
     *         totalIncVat: '[Money]'
     *     }
     */
    CartCalculationQueryHandler_dryRun(query) {
        return this.apiClient.invoke('front-office/CartCalculationQueryHandler', 'dryRun', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             lineId: '[SubscriptionProductId]',
     *             newProductId: '[ProductId]'
     *         }
     * Return dto:
     *     void
     */
    ChangeCrateProductCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeCrateProductCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             lines: {
     *                 productId: '[ProductId]',
     *                 quantity: '[int]',
     *                 oneTime: '[boolean]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    ChangeCratesAndBundlesCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeCratesAndBundlesCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerId: '[CustomerId]',
     *         consent: '[boolean]'
     *     }
     */
    ChangeCustomerConsentCommandHandler_getCommandTemplate(customerId) {
        return this.apiClient.invoke('front-office/ChangeCustomerConsentCommandHandler', 'getCommandTemplate', { customerId: customerId });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             customerId: '[CustomerId]',
     *             consent: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    ChangeCustomerConsentCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeCustomerConsentCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             lineId: '[SubscriptionProductId]',
     *             subLines: {
     *                 productId: '[ProductId]',
     *                 quantity: '[int]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    ChangeCustomizableContentCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeCustomizableContentCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     subscriptionId:
     *         {

     *         }
     *     paymentMeansId:
     *         {

     *         }
     * Return dto:
     *     void
     */
    ChangePaymentMeansCommandHandler_handle(subscriptionId, paymentMeansId) {
        return this.apiClient.invoke('front-office/ChangePaymentMeansCommandHandler', 'handle', { subscriptionId: subscriptionId, paymentMeansId: paymentMeansId });
    }

    /**
     * Parameter dto:
     *     subscriptionId:
     *         {

     *         }
     * Return dto:
     *     {
     *         subscriptionId: '[SubscriptionId]',
     *         firstName: '[String]',
     *         lastName: '[String]',
     *         streetAddress: '[String]',
     *         postalCode: '[String]',
     *         city: '[String]',
     *         phoneNumber: '[String]',
     *         email: '[String]',
     *         commentForDriver: '[String]',
     *         commentForPacking: '[String]',
     *         consent: '[boolean]'
     *     }
     */
    ChangeSubscriptionAddressCommandHandler_getCommandTemplate(subscriptionId) {
        return this.apiClient.invoke('front-office/ChangeSubscriptionAddressCommandHandler', 'getCommandTemplate', { subscriptionId: subscriptionId });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             commentForDriver: '[String]',
     *             commentForPacking: '[String]',
     *             consent: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    ChangeSubscriptionAddressCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeSubscriptionAddressCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     subscriptionId:
     *         {

     *         }
     * Return dto:
     *     {
     *         subscriptionId: '[SubscriptionId]',
     *         commentForPacking: '[String]'
     *     }
     */
    ChangeSubscriptionCommentForPackingCommandHandler_getCommandTemplate(subscriptionId) {
        return this.apiClient.invoke('front-office/ChangeSubscriptionCommentForPackingCommandHandler', 'getCommandTemplate', { subscriptionId: subscriptionId });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             commentForPacking: '[String]'
     *         }
     * Return dto:
     *     void
     */
    ChangeSubscriptionCommentForPackingCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeSubscriptionCommentForPackingCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             weekInterval: '[WeekInterval]'
     *         }
     * Return dto:
     *     void
     */
    ChangeSubscriptionIntervalCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeSubscriptionIntervalCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             lines: {
     *                 productId: '[ProductId]',
     *                 quantity: '[int]',
     *                 oneTime: '[boolean]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    ChangeWeekExtraCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ChangeWeekExtraCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscription: '[boolean]',
     *             weekInterval: '[WeekInterval]',
     *             weekDay: '[DayOfWeek]',
     *             startWeek: '[YearWeek]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             paymentMeansId: '[PaymentMeansId]',
     *             items: {
     *                 productId: '[ProductId]',
     *                 quantity: '[int]',
     *                 oneTime: '[boolean]',
     *                 subItems: {
     *                     productId: '[ProductId]',
     *                     quantity: '[int]',
     *                     oneTime: '[boolean]'
     *                 }
     *             },
     *             commentForPacking: '[String]',
     *             commentForDriver: '[String]'
     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         subscriptionId: '[SubscriptionId]'
     *     }
     */
    CheckoutCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/CheckoutCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             items: {
     *                 productId: '[ProductId]',
     *                 incrementQuantity: '[int]',
     *                 initialOneTimeValue: '[Boolean]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    CheckoutSubProductCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/CheckoutSubProductCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         items: {
     *             giftCardId: '[GiftCardId]',
     *             giftCardNumber: '[int]',
     *             initialAmount: '[Money]',
     *             remainingAmount: '[Money]',
     *             token: '[String]',
     *             expiryDate: '[LocalDate]',
     *             claimDate: '[LocalDate]'
     *         },
     *         totalRemainingAmount: '[Money]'
     *     }
     */
    ClaimedGiftCardsQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/ClaimedGiftCardsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     cmsFragmentKeys:
     *         {
     *             items: {
     *                 cmsFragmentKey: '[String]',
     *                 returnKey: '[String]',
     *                 imgWidth: '[Integer]',
     *                 imgHeight: '[Integer]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    CmsFragmentPublicQueryHandler_handle(cmsFragmentKeys) {
        return this.apiClient.invoke('front-office/CmsFragmentPublicQueryHandler', 'handle', { cmsFragmentKeys: cmsFragmentKeys });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             subscriptionProductId: '[SubscriptionProductId]',
     *             yearWeek: '[YearWeek]',
     *             productIdsToIncrement: {
     *                 productId: '[ProductId]',
     *                 increment: '[int]'
     *             }
     *         }
     * Return dto:
     *     {
     *         newSubscriptionProductId: '[SubscriptionProductId]'
     *     }
     */
    ConvertSubscriptionLineToCustomizableCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/ConvertSubscriptionLineToCustomizableCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         items: {
     *             productId: '[ProductId]',
     *             seoKey: '[String]',
     *             articleNumber: '[String]',
     *             name: '[String]',
     *             description: '[String]',
     *             descriptionShort: '[String]',
     *             imageId: '[ImageId]',
     *             imageUrl: '[String]',
     *             priceIncVat: '[BigDecimal]',
     *             minPriceIncVat: '[BigDecimal]',
     *             packingFeeIncVat: '[BigDecimal]',
     *             isCustomizable: '[boolean]',
     *             isDefaultCrate: '[boolean]',
     *             bundleQuantityCommitment: '[String]'
     *         }
     *     }
     */
    CrateCatalogQueryHandler_handle() {
        return this.apiClient.invoke('front-office/CrateCatalogQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             onlyFeatured1: '[boolean]',
     *             onlyFeatured2: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             productId: '[ProductId]',
     *             seoKey: '[String]',
     *             articleNumber: '[String]',
     *             name: '[String]',
     *             description: '[String]',
     *             descriptionShort: '[String]',
     *             imageId: '[ImageId]',
     *             imageUrl: '[String]',
     *             priceIncVat: '[BigDecimal]',
     *             minPriceIncVat: '[BigDecimal]',
     *             packingFeeIncVat: '[BigDecimal]',
     *             isCustomizable: '[boolean]',
     *             isDefaultCrate: '[boolean]',
     *             bundleQuantityCommitment: '[String]'
     *         }
     *     }
     */
    CrateCatalogQueryHandler_handleV2(query) {
        return this.apiClient.invoke('front-office/CrateCatalogQueryHandler', 'handleV2', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         paymentMeansId: '[PaymentMeansId]'
     *     }
     */
    CreateFakePaymentMeansCommandHandler_handle() {
        return this.apiClient.invoke('front-office/CreateFakePaymentMeansCommandHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     amount:
     *         {
     *             ZERO: '[Money]',
     *             amount: '[BigDecimal]'
     *         }
     *     continueUrl:
     *         {
     *             value: '[byte[]]',
     *             coder: '[byte]',
     *             hash: '[int]',
     *             hashIsZero: '[boolean]',
     *             serialVersionUID: '[long]',
     *             COMPACT_STRINGS: '[boolean]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             REPL: '[char]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]',
     *             LATIN1: '[byte]',
     *             UTF16: '[byte]'
     *         }
     *     cancelUrl:
     *         {
     *             value: '[byte[]]',
     *             coder: '[byte]',
     *             hash: '[int]',
     *             hashIsZero: '[boolean]',
     *             serialVersionUID: '[long]',
     *             COMPACT_STRINGS: '[boolean]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             REPL: '[char]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]',
     *             LATIN1: '[byte]',
     *             UTF16: '[byte]'
     *         }
     * Return dto:
     *     {
     *         paymentMeansId: '[PaymentMeansId]',
     *         url: '[String]'
     *     }
     */
    CreateQuickpayLinkCommandHandler_handle(amount, continueUrl, cancelUrl) {
        return this.apiClient.invoke('front-office/CreateQuickpayLinkCommandHandler', 'handle', { amount: amount, continueUrl: continueUrl, cancelUrl: cancelUrl });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             amount: '[Money]',
     *             continueUrl: '[String]',
     *             cancelUrl: '[String]',
     *             redirectReference: '[String]'
     *         }
     * Return dto:
     *     {
     *         paymentMeansId: '[PaymentMeansId]',
     *         url: '[String]'
     *     }
     */
    CreateQuickpayLinkCommandHandler_handle_v2(command) {
        return this.apiClient.invoke('front-office/CreateQuickpayLinkCommandHandler', 'handle_v2', { command: command });
    }

    /**
     * Parameter dto:
     *     subscriptionId:
     *         {

     *         }
     * Return dto:
     *     {
     *         endWeeks: {
     *             id: '[YearWeek]',
     *             name: '[String]'
     *         }
     *     }
     */
    EndWeeksForDropdownQueryHandler_handle(subscriptionId) {
        return this.apiClient.invoke('front-office/EndWeeksForDropdownQueryHandler', 'handle', { subscriptionId: subscriptionId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         paymentMeans: {
     *             paymentMeansId: '[PaymentMeansId]',
     *             acquirer: '[Acquirer]',
     *             orderId: '[String]',
     *             type: '[String]',
     *             brand: '[String]',
     *             last4: '[String]',
     *             expMonth: '[Integer]',
     *             expYear: '[Integer]',
     *             canCancel: '[boolean]',
     *             active: '[boolean]'
     *         }
     *     }
     */
    ExistingPaymentMeansQueryHandler_handle() {
        return this.apiClient.invoke('front-office/ExistingPaymentMeansQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             consent: '[boolean]',
     *             debugDescription: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    FindOrCreateCustomerCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/FindOrCreateCustomerCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             giftCardToken: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    GiftCardClaimCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/GiftCardClaimCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             amount: '[Money]',
     *             paymentMeansId: '[PaymentMeansId]',
     *             message: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    GiftCardPurchaseCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/GiftCardPurchaseCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             amount: '[Money]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             message: '[String]'
     *         }
     * Return dto:
     *     void
     */
    GiftCardPurchaseWithoutPaymentMeansCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/GiftCardPurchaseWithoutPaymentMeansCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             subscriptionId: '[SubscriptionId]',
     *             subscriptionLineId: '[SubscriptionProductId]',
     *             subscriptionSubLineId: '[SubscriptionProductId]',
     *             quantityIncrement: '[int]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    IncrementSubscriptionLineCommandHandler_handle(command) {
        return this.apiClient.invoke('front-office/IncrementSubscriptionLineCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         existingAddresses: {
     *             subscriptionId: '[SubscriptionId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             commentForDriver: '[String]'
     *         }
     *     }
     */
    MyExistingAddressesQueryHandler_handle() {
        return this.apiClient.invoke('front-office/MyExistingAddressesQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     orderId:
     *         {

     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         orderNumber: '[int]',
     *         subscriptionNumber: '[int]',
     *         customerId: '[CustomerId]',
     *         firstName: '[String]',
     *         lastName: '[String]',
     *         streetAddress: '[String]',
     *         postalCode: '[String]',
     *         city: '[String]',
     *         phoneNumber: '[String]',
     *         email: '[String]',
     *         commentForPacking: '[String]',
     *         commentForDriver: '[String]',
     *         subscriptionId: '[SubscriptionId]',
     *         orderDate: '[LocalDate]',
     *         deliveryDate: '[LocalDate]',
     *         totalIncVat: '[BigDecimal]',
     *         paymentId: '[PaymentId]',
     *         lines: {
     *             orderLineId: '[OrderLineId]',
     *             productId: '[ProductId]',
     *             description: '[String]',
     *             priceIncVat: '[Money]',
     *             quantity: '[int]',
     *             totalIncVat: '[Money]',
     *             sortOrder: '[int]',
     *             subLines: {
     *                 orderLineId: '[OrderLineId]',
     *                 productId: '[ProductId]',
     *                 description: '[String]',
     *                 priceIncVat: '[Money]',
     *                 quantity: '[int]',
     *                 totalIncVat: '[Money]',
     *                 sortOrder: '[int]',
     *                 syntheticLine: '[boolean]'
     *             }
     *         },
     *         vatLines: {
     *             vatLineId: '[OrderVatLineId]',
     *             vatRate: '[BigDecimal]',
     *             baseAmount: '[Money]',
     *             vatAmount: '[Money]'
     *         },
     *         roundingError: '[Money]'
     *     }
     */
    MyOrderDetailsQueryHandler_handle(orderId) {
        return this.apiClient.invoke('front-office/MyOrderDetailsQueryHandler', 'handle', { orderId: orderId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         orders: {
     *             orderId: '[OrderId]',
     *             orderNumber: '[int]',
     *             subscriptionId: '[SubscriptionId]',
     *             orderDate: '[LocalDate]',
     *             deliveryDate: '[LocalDate]',
     *             totalIncVat: '[Money]',
     *             outstandingTotalIncVat: '[Money]',
     *             cancelled: '[boolean]',
     *             failed: '[boolean]'
     *         }
     *     }
     */
    MyOrdersQueryHandler_handle() {
        return this.apiClient.invoke('front-office/MyOrdersQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             skip: '[Integer]',
     *             take: '[Integer]'
     *         }
     * Return dto:
     *     {
     *         orders: {
     *             orderId: '[OrderId]',
     *             orderNumber: '[int]',
     *             subscriptionId: '[SubscriptionId]',
     *             orderDate: '[LocalDate]',
     *             deliveryDate: '[LocalDate]',
     *             totalIncVat: '[Money]',
     *             outstandingTotalIncVat: '[Money]',
     *             cancelled: '[boolean]',
     *             failed: '[boolean]'
     *         }
     *     }
     */
    MyOrdersQueryHandler_handleV2(query) {
        return this.apiClient.invoke('front-office/MyOrdersQueryHandler', 'handleV2', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         subscriptions: {
     *             subscriptionId: '[SubscriptionId]',
     *             subscriptionNumber: '[int]',
     *             weekIntervalInt: '[int]',
     *             weekInterval: '[WeekInterval]',
     *             startWeek: '[YearWeek]',
     *             endWeekInclusive: '[YearWeek]',
     *             weekOffset: '[int]',
     *             weekDay: '[DayOfWeek]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             yearWeekOfProjectedLines: '[YearWeek]',
     *             lines: {
     *                 subscriptionProductId: '[SubscriptionProductId]',
     *                 productId: '[ProductId]',
     *                 name: '[String]',
     *                 oneTime: '[boolean]',
     *                 priceIncVat: '[Money]',
     *                 quantity: '[int]',
     *                 totalIncVat: '[Money]',
     *                 isCustomizable: '[boolean]',
     *                 isCrate: '[boolean]',
     *                 automaticLine: '[boolean]',
     *                 backofficeOnly: '[Boolean]',
     *                 subLines: {
     *                     subscriptionProductId: '[SubscriptionProductId]',
     *                     productId: '[ProductId]',
     *                     name: '[String]',
     *                     oneTime: '[boolean]',
     *                     priceIncVat: '[Money]',
     *                     quantity: '[int]',
     *                     totalIncVat: '[Money]',
     *                     automaticLine: '[boolean]',
     *                     syntheticLine: '[boolean]',
     *                     backofficeOnly: '[Boolean]'
     *                 }
     *             },
     *             totalIncVat: '[Money]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             consent: '[Boolean]',
     *             commentForPacking: '[String]',
     *             commentForDriver: '[String]',
     *             paymentMeans: '[PaymentMeansDto]',
     *             projectedDeliveryWeeks: {
     *                 yearWeek: '[YearWeek]',
     *                 formattedYearWeek: '[String]',
     *                 deliveryDate: '[LocalDate]',
     *                 dayOfWeek: '[DayOfWeek]',
     *                 orderCutoff: '[String]',
     *                 willHaveDelivery: '[boolean]',
     *                 isBeforeStartWeek: '[boolean]',
     *                 hasPause: '[boolean]',
     *                 hasGlobalPause: '[boolean]',
     *                 isAfterEndWeek: '[boolean]',
     *                 canChange: '[boolean]',
     *                 isDisjoint: '[boolean]'
     *             },
     *             nextDeliveryDate: '[LocalDate]',
     *             existingOrderBetweenNowAndNextAffectableDeliveryDate_deliveryDate: '[LocalDate]',
     *             existingOrderBetweenNowAndNextAffectableDeliveryDate_orderId: '[OrderId]'
     *         },
     *         totalAvailableGiftCardAmount: '[Money]',
     *         giftCardsPurchased: {
     *             giftCardId: '[GiftCardId]',
     *             giftCardNumber: '[int]',
     *             purchaseDate: '[LocalDate]',
     *             expiryDate: '[LocalDate]',
     *             initialAmount: '[Money]',
     *             message: '[String]',
     *             token: '[String]'
     *         }
     *     }
     */
    MyPageQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/MyPageQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             newsItemIdOrSeoKey: '[String]',
     *             search: '[String]',
     *             limit: '[int]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             newsItemId: '[NewsItemId]',
     *             seoKey: '[String]',
     *             name: '[String]',
     *             content: '[String]',
     *             contentSmall: '[String]',
     *             imageIdSmall: '[ImageId]',
     *             imageIdLarge: '[ImageId]',
     *             imageSmallUrl: '[String]',
     *             imageLargeUrl: '[String]',
     *             videoUrl: '[String]',
     *             createdDateTime: '[LocalDateTime]',
     *             publishDateTime: '[LocalDateTime]'
     *         }
     *     }
     */
    NewsItemQueryHandler_handle(command) {
        return this.apiClient.invoke('front-office/NewsItemQueryHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             subscriptionId: '[SubscriptionId]'
     *         }
     * Return dto:
     *     {
     *         subscriptionItems: {
     *             paymentId: '[PaymentId]',
     *             deliveryDate: '[LocalDate]',
     *             isDeliveryDateInFuture: '[boolean]',
     *             latestStatusMsg: '[String]'
     *         },
     *         isMissingPaymentMeans: '[boolean]'
     *     }
     */
    PaymentNotificationsQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/PaymentNotificationsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productCategoryIdOrSeoKey: '[String]'
     *         }
     * Return dto:
     *     {
     *         id: '[ProductCategoryId]',
     *         productCategoryName: '[String]',
     *         iconKey: '[String]'
     *     }
     */
    ProductCategoryQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/ProductCategoryQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productIdOrSeoKey: '[String]',
     *             maxAdditionalWeekCount: '[int]'
     *         }
     * Return dto:
     *     {
     *         productId: '[ProductId]',
     *         seoKey: '[String]',
     *         articleNumber: '[String]',
     *         name: '[String]',
     *         unit: '[String]',
     *         nameAndUnit: '[String]',
     *         description: '[String]',
     *         descriptionShort: '[String]',
     *         descriptionMetaTag: '[String]',
     *         imageId: '[ImageId]',
     *         imageUrl: '[String]',
     *         cmsContent1: '[String]',
     *         cmsContent2: '[String]',
     *         priceIncVat: '[BigDecimal]',
     *         minPriceIncVat: '[BigDecimal]',
     *         packingFeeIncVat: '[BigDecimal]',
     *         isAvailable: '[boolean]',
     *         isCrate: '[boolean]',
     *         isCustomizable: '[boolean]',
     *         isDefaultCrate: '[boolean]',
     *         bundleQuantityCommitment: '[String]',
     *         bundleConfigurations: {
     *             bundleConfigurationId: '[BundleConfigurationId]',
     *             yearWeek: '[YearWeek]',
     *             lines: {
     *                 bundleConfigurationLineId: '[BundleConfigurationLineId]',
     *                 quantity: '[int]',
     *                 productId: '[ProductId]',
     *                 supplierId: '[SupplierId]',
     *                 supplierSeoKey: '[String]',
     *                 productName: '[String]',
     *                 productUnit: '[String]',
     *                 supplierName: '[String]',
     *                 description: '[String]',
     *                 descriptionShort: '[String]',
     *                 imageId: '[ImageId]',
     *                 imageUrl: '[String]'
     *             }
     *         }
     *     }
     */
    ProductDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/ProductDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             recipeIdOrSeoKey: '[String]',
     *             search: '[String]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             recipeId: '[RecipeId]',
     *             seoKey: '[String]',
     *             name: '[String]',
     *             ingress: '[String]',
     *             description1: '[String]',
     *             description2: '[String]',
     *             description3: '[String]',
     *             descriptionMetaTag: '[String]',
     *             imageIdSmall: '[ImageId]',
     *             imageIdLarge: '[ImageId]',
     *             imageSmallUrl: '[String]',
     *             imageLargeUrl: '[String]',
     *             attachmentBlobId: '[BlobId]',
     *             attachmentUrl: '[String]',
     *             createdDateTime: '[LocalDateTime]',
     *             publishDateTime: '[LocalDateTime]'
     *         }
     *     }
     */
    RecipeQueryHandler_handle(command) {
        return this.apiClient.invoke('front-office/RecipeQueryHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     subscriptionId:
     *         {

     *         }
     *     yearWeek:
     *         {
     *             yearWeekIsoString: '[String]'
     *         }
     *     pause:
     *         {

     *         }
     * Return dto:
     *     void
     */
    SetPauseCommandHandler_handle(subscriptionId, yearWeek, pause) {
        return this.apiClient.invoke('front-office/SetPauseCommandHandler', 'handle', { subscriptionId: subscriptionId, yearWeek: yearWeek, pause: pause });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         startWeeks: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    StartWeeksForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('front-office/StartWeeksForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             supplierId: '[SupplierId]',
     *             cratesInsteadOfSubProducts: '[Boolean]',
     *             isAvailable: '[Boolean]',
     *             claimToBeBackoffice: '[Boolean]'
     *         }
     * Return dto:
     *     {
     *         categories: {
     *             productCategoryId: '[ProductCategoryId]',
     *             name: '[String]',
     *             seoKey: '[String]',
     *             iconKey: '[String]'
     *         },
     *         products: {
     *             productCategoryId: '[ProductCategoryId]',
     *             productId: '[ProductId]',
     *             articleNumber: '[String]',
     *             productSeoKey: '[String]',
     *             supplierId: '[SupplierId]',
     *             supplierSeoKey: '[String]',
     *             supplierName: '[String]',
     *             name: '[String]',
     *             unit: '[String]',
     *             isFeaturedOnSubProducts: '[boolean]',
     *             isAvailable: '[boolean]',
     *             isBundle: '[boolean]',
     *             imageId: '[ImageId]',
     *             imageUrl: '[String]',
     *             description: '[String]',
     *             descriptionShort: '[String]',
     *             priceIncVat: '[Money]',
     *             presentationSort: '[int]',
     *             featuredProductsSort: '[int]'
     *         }
     *     }
     */
    SubProductCategorizedQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/SubProductCategorizedQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             supplierIdOrSeoKey: '[String]'
     *         }
     * Return dto:
     *     {
     *         suppliers: {
     *             supplierId: '[SupplierId]',
     *             seoKey: '[String]',
     *             name: '[String]',
     *             description: '[String]',
     *             descriptionMetaTag: '[String]',
     *             ingress: '[String]',
     *             imageSmallUrl: '[String]',
     *             imageLargeUrl: '[String]',
     *             imageSmall: '[ImageId]',
     *             imageLarge: '[ImageId]'
     *         }
     *     }
     */
    SupplierIndexQueryHandler_handle(command) {
        return this.apiClient.invoke('front-office/SupplierIndexQueryHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         rowNumber: '[int]',
     *         hasCustomer: '[boolean]',
     *         hasSubscription: '[boolean]',
     *         subscriptionId: '[SubscriptionId]',
     *         isCustomizable: '[Boolean]',
     *         subscriptionProductId: '[SubscriptionProductId]',
     *         existingCrateProductName: '[String]'
     *     }
     */
    UserInfoQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/UserInfoQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             username: '[String]'
     *         }
     * Return dto:
     *     {
     *         alreadyExists: '[boolean]'
     *     }
     */
    UsernameAlreadyExistsQueryHandler_handle(command) {
        return this.apiClient.invoke('front-office/UsernameAlreadyExistsQueryHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     paymentMeansId:
     *         {

     *         }
     * Return dto:
     *     {
     *         paymentMeansId: '[PaymentMeansId]',
     *         ok: '[boolean]'
     *     }
     */
    VerifyPaymentMeansQueryHandler_handle(paymentMeansId) {
        return this.apiClient.invoke('front-office/VerifyPaymentMeansQueryHandler', 'handle', { paymentMeansId: paymentMeansId });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             paymentMeansId: '[PaymentMeansId]',
     *             redirectReference: '[String]'
     *         }
     * Return dto:
     *     {
     *         paymentMeansId: '[PaymentMeansId]',
     *         ok: '[boolean]'
     *     }
     */
    VerifyPaymentMeansQueryHandler_handle_v2(query) {
        return this.apiClient.invoke('front-office/VerifyPaymentMeansQueryHandler', 'handle_v2', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         weekDays: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    WeekDaysForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('front-office/WeekDaysForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             subscriptionId: '[SubscriptionId]'
     *         }
     * Return dto:
     *     {
     *         weekIntervals: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    WeekIntervalsForDropdownQueryHandler_handle(query) {
        return this.apiClient.invoke('front-office/WeekIntervalsForDropdownQueryHandler', 'handle', { query: query });
    }
}
